import React, { Component } from 'react';
import Utils from '@/utils';
import { message } from 'antd';
import sentGAEvent from '@/ga';
// import TipsModal from '@/components/common/tipModal/TipsModal'
import TipsModal from '@/components/common/exceed20Modal/TipsModal';
import { editorList } from '@/constants/url';
import FixMessage from '@/components/fixedMessage/fixedMessage';
import ConvertWorkContentRender from './chidlren/ConvertWorkContentRender';
import ConvertWorkHeaderRender from './chidlren/ConvertWorkHeaderRender';
import ConvertWorkFooterRender from './chidlren/ConvertWorkFooterRender';
import ConvertModalRender from './chidlren/ConvertModalRender';
import Device from 'current-device';
import '@/assets/convert.less';

class ConvertWorkFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      video: [
        'mkv',
        'mov',
        'mp4',
        'avi',
        'wmv',
        'vob',
        'webm',
        'asf',
        'f4v',
        'flv',
        'mpg',
        'mpeg',
        'mxf',
        'ogv',
        'swf',
        'ts',
      ],
      // audio: ["wav", "mp3", "m4a", "aac", "ogg", "flac", "wv", "alac", "opus", "ape"],
      audio: ['wav', 'mp3', 'm4a', 'aac', 'ogg', 'flac', 'wv'],
      image: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'tiff', 'webp', 'ico'],
      modalVisible: false,
      linkToEditorGuid: null,
      linkToEditorWorkType: null,
      messageShow: false,
      messageText: '',
    };
  }

  handleConvertType = (guid, fileType, convertType) => {
    console.log(guid, fileType, convertType);
    const files = [...this.props.files];
    files.forEach((item) => {
      if (item.guid === guid) {
        item.convertType = convertType;
        item.convertFileType = fileType;
      }
    });
    this.props.onFilesChange(files);
  };

  uploadProps = {
    accept: this.props.accept
      ? this.props.accept
      : 'video/*,.mkv,.3gp,.f4v,.rm,.rmvb,.mts,.mxf,.asf,.flv,.vob,.mp3',
    onChange: (info) => {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        console.log(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        console.log(`${info.file.name} file upload failed.`);
        this.setState({ uploadFail: true });
      }
    },
    beforeUpload: (file) => {
      if (this.props.files.length >= 2) {
        return false;
      }
      // if (file.size >= 20 * 1024 * 1024) {
      //   this.setState({
      //     warningInfo: true,
      //     warningInfoText: "Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.",
      //     warningInfoObj: {
      //       type: "size",
      //       size: (file.size / 1024 / 1024).toFixed(2),
      //     },
      //   });
      // } else
      if (!Utils.validate(file, this.props.accept)) {
        this.setState({
          warningInfo: true,
          warningInfoText: 'This format is not supported currently.',
          warningInfoObj: {
            type: 'format',
            format: /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase(),
          },
        });
        message('This format is not supported currently.');
      } else {
        if (file.size >= 20 * 1024 * 1024) {
          if (Utils.isNeedToShowPurchaseModal()) {
            return false;
          }
        }
        sentGAEvent({
          category: 'Convert',
          action: 'ConvertUpload',
          label:
            /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
            '_' +
            (file.size / 1024 / 1024).toFixed(2),
        });
        this.setState({
          file: file,
          uploadClick: false,
        });
        const files = [...this.props.files];
        const newFile = {
          name: file.name,
          guid: new Date().getTime(),
          size: file.size,
          status: 'ready',
          uploadStatus: false,
          fileObj: file,
          type: file.type,
          convertType:
            file.type.indexOf('video') !== -1
              ? 'mp4'
              : file.type.indexOf('audio') !== -1
              ? 'mp3'
              : file.type.indexOf('image') !== -1
              ? 'jpg'
              : this.props.type === 'video'
              ? 'mp4'
              : this.props.type === 'audio'
              ? 'mp3'
              : 'jpg',
          convertFileType:
            file.type.indexOf('video') !== -1
              ? 'video'
              : file.type.indexOf('audio') !== -1
              ? 'audio'
              : file.type.indexOf('image') !== -1
              ? 'image'
              : this.props.type,
          fileType:
            file.type.indexOf('video') !== -1
              ? 'video'
              : file.type.indexOf('audio') !== -1
              ? 'audio'
              : file.type.indexOf('image') !== -1
              ? 'image'
              : this.props.type,
        };
        files.push(newFile);
        this.props.onFilesChange(files);
      }
      return false;
    },
  };

  isHideFooter = () => {
    return (
      this.props.files.filter(
        (item) =>
          item.status === 'success' || item.status.indexOf('Failed') !== -1
      ).length === this.props.files.length &&
      !this.props.files.some(
        (item) =>
          item.status === 'success' &&
          item.convertFileType === 'video' &&
          item.fileType === 'video'
      )
    );
  };

  handleCloseFile = (guid) => {
    const file = this.props.files.filter((item) => item.guid === guid);
    console.log('清除请求');
    if (file.length && file[0].status === 'converting') {
      console.log('清除请求converting');
      if (this.props.fetchAbort) {
        this.props.fetchAbort();
      }
      Utils.cancleProgress(file[0].processNum, file.startTime);
    } else if (file.length && file[0].status === 'uploading') {
      console.log('清除请求uploading');
      const xhr = this.props.uploadXHR;
      if (xhr) {
        xhr.abort();
      }
    }
    this.handleDeleteFile(guid);
  };

  handleDeleteFile = (guid) => {
    const newFiles = this.props.files.filter((item) => item.guid !== guid);
    this.props.onFilesChange(newFiles);
  };

  handleDownloadAll = () => {
    this.props.files
      .filter((item) => item.status === 'success' && item.fileurl)
      .forEach((item) => {
        Utils.downloadFile(item, item.convertType);
      });
  };

  handleConvertModalShow = () => {
    this.setState({ modalVisible: true });
  };

  handleConvertModalHide = () => {
    this.setState({ modalVisible: false });
  };

  handleContinueFile = (e) => {
    const value = e.target.value;
    this.setState({
      linkToEditorGuid: value,
    });
  };

  handleLinkToOnlineEditor = () => {
    const { linkToEditorGuid, linkToEditorWorkType } = this.state;
    sentGAEvent({
      category: 'Convert',
      action: 'ConvertContEdit',
      label: linkToEditorWorkType,
    });
    const file = this.props.files.filter(
      (item) => item.guid === linkToEditorGuid
    );
    if (file.length) {
      console.log(file[0]);
      let blob;
      try {
        blob = new Blob([file[0].fileObj], { type: file[0].fileObj.type });
      } catch (err) {
        console.log('Turn Blob Error: ', err);
        return false;
      }
      const blobUrl = URL.createObjectURL(blob);
      // let href = "https://www.hitpaw.com/online-tools-test/?type=convert&work=" + linkToEditorWorkType + "&blob=" + blobUrl;
      console.log(blobUrl);
      let href = `${editorList.get(
        'editor'
      )}?type=convert&work=${linkToEditorWorkType}&blob=${blobUrl}`;
      console.log(href);
      window.open(href);
    }
  };

  handleContinue = (workType) => {
    this.setState(
      {
        linkToEditorWorkType: workType,
      },
      () => {
        const files = this.props.files.filter(
          (item) =>
            item.fileType === 'video' &&
            item.convertFileType === 'video' &&
            item.status === 'success'
        );
        console.log('files', files);
        if (files.length) {
          if (files.length > 1) {
            this.handleConvertModalShow();
          } else {
            this.setState(
              {
                linkToEditorGuid: files[0].guid,
              },
              () => {
                this.handleLinkToOnlineEditor();
              }
            );
          }
        }
      }
    );
  };

  handleAddFileMoreThanLimit = () => {
    if (Device.mobile()) {
      this.setState({
        messageShow: true,
        messageText:
          'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
      });
    } else {
      this.setState({
        warningInfo: true,
        warningInfoText:
          'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
        // warningInfoObj: {
        //   type: "format",
        //   format: /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase(),
        // },
      });
    }
  };

  handleAddFileMoreThanLimit1 = () => {
    if (Device.mobile()) {
      this.setState({
        messageShow: true,
        messageText:
          'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
      });
    } else {
      this.setState({
        warningInfo: true,
        warningInfoText:
          'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
        // warningInfoObj: {
        //   type: "format",
        //   format: /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase(),
        // },
      });
    }
  };

  render() {
    const isConverted =
      this.props.files.filter(
        (item) =>
          item.status === 'success' || item.status.indexOf('Failed') !== -1
      ).length === this.props.files.length &&
      this.props.files.some((item) => item.status === 'success');
    console.log('isConverter', isConverted);
    return (
      <div className='workplace'>
        <FixMessage
          visible={this.state.messageShow}
          onCancel={() => {
            this.setState({ messageShow: false });
          }}
          content={this.state.messageText}
        />
        <ConvertWorkHeaderRender
          files={this.props.files}
          uploadProps={this.uploadProps}
          handleAddFileMoreThanLimit={this.handleAddFileMoreThanLimit}
        />
        <ConvertWorkContentRender
          video={this.state.video}
          audio={this.state.audio}
          image={this.state.image}
          files={this.props.files}
          handleConvertType={this.handleConvertType}
          handleCloseFile={this.handleCloseFile}
          handleDownloadAll={this.handleDownloadAll}
          isConverted={isConverted}
          handleSubmitAgain={this.props.handleSubmitAgain}
          type={this.props.type}
        />

        <ConvertWorkFooterRender
          convertBtnDisabled={this.props.files.some(
            (item) =>
              item.status === 'converting' || item.status === 'uploading'
          )}
          isConverted={isConverted}
          isHideFooter={this.isHideFooter}
          handleDownloadAll={this.handleDownloadAll}
          requstConvert={() => {
            this.props.handleConvert();
          }}
          handleContinue={this.handleContinue}
          type={this.props.type}
        />

        <ConvertModalRender
          files={this.props.files}
          visible={this.state.modalVisible}
          linkToEditorWorkType={this.state.linkToEditorWorkType}
          onCancel={this.handleConvertModalHide}
          handleContinueFile={this.handleContinueFile}
          handleContinue={this.handleContinue}
          handleLinkToOnlineEditor={this.handleLinkToOnlineEditor}
        />
        <TipsModal
          visible={this.state.warningInfo}
          onCancel={() => {
            this.setState({ warningInfo: false });
          }}
          content={this.state.warningInfoText}
          tipsObj={this.state.warningInfoObj}
          cancelBtnHandle={() => {
            this.setState({ warningInfo: false });
          }}
          hasDownload
        />
      </div>
    );
  }
}

export default ConvertWorkFunction;
